<div
  class="widget-preview-popup"
  [style.width.px]="width"
  [style.height.px]="height"
>
  <div class="popup-header" cdkDragHandle>
    <div class="popup-title">
      {{ "widget-preview-popup.title.widget-preview" | translate }}:
      {{ widget?.title }}
    </div>
    <div class="popup-actions">
      <sui-button
        size="sm"
        variant="primary"
        [leadingIcon]="['fas', 'map-pin']"
        [iconOnly]="true"
        [ariaLabel]="'btn.tooltip.pin-preview' | translate"
        [suiTooltip]="'btn.tooltip.pin-preview' | translate"
        (click)="onDock()"
      ></sui-button>
      <sui-button
        size="sm"
        variant="danger"
        [leadingIcon]="['fas', 'times']"
        [iconOnly]="true"
        ariaLabel="Close"
        (click)="onCloseClick()"
      ></sui-button>
    </div>
  </div>

  <div class="popup-content">
    @if (widget) {
      @if (isLoading) {
        <app-loading [size]="'3x'"></app-loading>
      } @else {
        <app-widget-card
          [widget]="widget"
          [widgetPreview]="true"
        ></app-widget-card>
      }
    }
  </div>
</div>
